const TileSliderController = {
  init() {
    $('.js-tiles-slider').each( (_, el) => {
      const slider = tileSlider();
      slider.setup( $(el) );
    } );
  }
};
$(TileSliderController.init());

function tileSlider() {
  return {
    active_item: 1,
    $prev_button: [],
    $next_button: [],
    $items: [],
    $slider: [],
    track: null,
    gap: 15,
    slide_width: 100,
    setup($slider) {
      this.$slider = $slider;
      this.gap = parseInt(getComputedStyle($slider.get(0)).getPropertyValue('--tile-gap-width'), 10);

      const $wrapper = $slider.closest('.js-tiles-slider-wrapper');
      if ( $wrapper.length === 0 ) { return; }

      this.$items = $slider.find('.js-tiles-slider-item');

      this.track = $slider.parent().get(0);
      this.track.style.setProperty('--tiles-count', this.$items.length);

      this.slide_width = this.$items.get(0).getBoundingClientRect().width;
      if (this.$items.length >= 2) {
        this.injectNav($wrapper);
        $wrapper.on('click', '.js-button-prev', event => this.prevClick(event));
        $wrapper.on('click', '.js-button-next', event => this.nextClick(event));
        this.setNavState();
      }
    },
    setNavState() {
      if ( !this.hasPrev() ) {
        this.disable(this.$prev_button);
        this.enable(this.$next_button);
      } else if ( !this.hasNext() ) {
        this.enable(this.$prev_button);
        this.disable(this.$next_button);
      } else {
        this.enable(this.$prev_button);
        this.enable(this.$next_button);
      }
    },
    scrollBy() {
      return this.slide_width + this.gap;
    },
    prevClick() {
      if ( this.hasPrev() ) {
        this.active_item--;
        const left = (this.active_item - 1) * this.scrollBy();
        this.track.scrollTo({ left, behavior: 'smooth' });
        this.setNavState();
      }
    },
    nextClick() {
      if ( this.hasNext() ) {
        this.active_item++;
        const left = (this.active_item - 1) * this.scrollBy();
        this.track.scrollTo({ left, behavior: 'smooth' });
        this.setNavState();
      }
    },
    hasPrev() {
      return this.active_item > 1;
    },
    hasNext() {
      return this.active_item < this.$items.length;
    },
    enable($button) {
      $button.removeClass('is-disabled');
      $button.removeAttr('disabled');
    },
    disable($button) {
      $button.addClass('is-disabled');
      $button.attr('disabled', 'disabled');
    },
    injectNav($wrapper) {
      this.$prev_button = $(`<button type="button" class="l-tiles__slider-button--prev js-button-prev"></button>`);
      this.$next_button = $(`<button type="button" class="l-tiles__slider-button--next js-button-next"></button>`);
      const $nav = $(`<nav class="l-tiles__slider-nav" />`);
      $nav.append(this.$prev_button);
      $nav.append(this.$next_button);
      $wrapper.prepend($nav);
    }
  }
}

